import { fromJS } from 'immutable'
import {
  TIMESHEET_STATUS_REQUEST,
  TIMESHEET_STATUS_SUCCESS,
  TIMESHEET_STATUS_FAILURE,
  TIMESHEET_STATUS_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case TIMESHEET_STATUS_REQUEST:
      return state
        .set('isFetching', true)
    case TIMESHEET_STATUS_SUCCESS:
      return state
        .set('timesheetStatus', fromJS(action.payload))
        .set('isFetching', false)
        .set('status', 200)
    case TIMESHEET_STATUS_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
        .set('timesheetStatus', fromJS(action.payload.message))
        .set('status', 'Error')
        .set('message', fromJS(action.payload.response.message))
    case TIMESHEET_STATUS_RESET:
      return state
        .delete('timesheetStatus')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/timesheet/timesheet-status-get-reducer.js